<svg fill="none" height="20" viewBox="0 0 24 20" width="24" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M9.6 19.9349V12.899H14.4V19.9349H20.4V10.5537H24L12 0L0 10.5537H3.6V19.9349H9.6Z"
    fill="white"
    fill-opacity="0.75"
  />
</svg>
